
import { useQuery } from "@tanstack/react-query";

import { QKey } from "src/lib/queryKeyStore";

import { partnerInfo } from "./fetcher";

interface UsePartnerInfoOptions {
  enabled?: boolean;
}

export const usePartnerInfo = (options: UsePartnerInfoOptions = {}) => useQuery({
  queryKey: [QKey.PARTNER_INFO],
  queryFn: () => partnerInfo(),
  enabled: options.enabled ?? true,
});